import { render, staticRenderFns } from "./DrawerColumn.vue?vue&type=template&id=3a8687a8"
import script from "./DrawerColumn.vue?vue&type=script&lang=ts"
export * from "./DrawerColumn.vue?vue&type=script&lang=ts"
import style0 from "./DrawerColumn.vue?vue&type=style&index=0&id=3a8687a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports